exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tl-button {\n  display: inherit;\n  padding-left: 15px;\n  padding-right: 15px; }\n  .tl-button:focus {\n    outline: none; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/vendor/treeline-shared-components/button/button.scss
 ** module id = 82
 ** module chunks = 1 2 3 4 7 8 9 15 18 19 24 27 28 30 33 46 51 80 83 94 106 111 132 146 207
 **/